import { render, staticRenderFns } from "./file-template-manager.vue?vue&type=template&id=7a2c666e&scoped=true"
import script from "./file-template-manager.vue?vue&type=script&lang=js"
export * from "./file-template-manager.vue?vue&type=script&lang=js"
import style0 from "./file-template-manager.vue?vue&type=style&index=0&id=7a2c666e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c666e",
  null
  
)

export default component.exports